import React from 'react';
import {JobCardListAPI} from './JobCardListAPI';
import {JobCardListStatic} from './JobCardListStatic';
import type {JobCardListProps} from './types';

import './JobCardList.scss';

export const JobCardList = ({
    title,
    tableOption,
    link,
    headerAction,
}: JobCardListProps) => {
    const isApiDriven =
        typeof tableOption.data === 'undefined' || !!tableOption.api;

    if (isApiDriven) {
        return (
            <JobCardListAPI
                title={title}
                tableOption={tableOption}
                link={link}
                headerAction={headerAction}
            />
        );
    }

    return (
        <JobCardListStatic
            title={title}
            headerAction={headerAction}
            tableOption={tableOption}
            link={link}
        />
    );
};
